// dataLayer (GTM / GA4) + Meta Pixel ecommerce events. Never pass names, emails, phones or addresses here — only order/product data.
const dl = () => (window.dataLayer = window.dataLayer || []);
const consent = () => window.__urbanConsent || { analytics: false, marketing: false };

const gaItem = (p, qty = 1) => ({ item_id: p.product_id || p.id, item_name: p.name, price: Number(p.price ?? p.display_price ?? p.base_price ?? 0), quantity: qty, item_brand: p.business_name || undefined });
const fbContents = (items) => items.map((i) => ({ id: i.item_id, quantity: i.quantity, item_price: i.price }));

function push(event, ecommerce, fb) {
  (window.__urbanEvents = window.__urbanEvents || []).push({ event, ecommerce, at: Date.now() });
  dl().push({ ecommerce: null });
  dl().push({ event, ecommerce });
  if (window.__urbanDirectGa && window.gtag && consent().analytics) window.gtag("event", event, ecommerce);
  if (fb && window.fbq && consent().marketing) {
    const [name, data, opts] = fb;
    window.fbq("track", name, data, opts);
  }
}

export const trackViewItem = (p) => {
  const item = gaItem(p);
  push("view_item", { currency: "USD", value: item.price, items: [item] },
    ["ViewContent", { content_ids: [item.item_id], content_name: item.item_name, content_type: "product", value: item.price, currency: "USD" }]);
};

export const trackAddToCart = (p, qty = 1, unitPrice) => {
  const item = { ...gaItem(p, qty), price: Number(unitPrice ?? gaItem(p).price) };
  const value = Number((item.price * qty).toFixed(2));
  push("add_to_cart", { currency: "USD", value, items: [item] },
    ["AddToCart", { content_ids: [item.item_id], content_name: item.item_name, content_type: "product", contents: fbContents([item]), value, currency: "USD" }]);
};

export const trackBeginCheckout = (cart, value, channel) => {
  const items = cart.map((l) => gaItem(l, l.quantity));
  push("begin_checkout", { currency: "USD", value: Number(value.toFixed(2)), items, channel },
    ["InitiateCheckout", { content_ids: items.map((i) => i.item_id), content_type: "product", contents: fbContents(items), num_items: items.reduce((n, i) => n + i.quantity, 0), value: Number(value.toFixed(2)), currency: "USD" }]);
};

// Only called after the server's one-shot claim says fire=true, so a refresh or second tab never re-sends the purchase.
export const trackPurchase = (ecommerce, eventId) => {
  push("purchase", { ...ecommerce, event_id: eventId },
    ["Purchase", { value: ecommerce.value, currency: ecommerce.currency, content_type: "product", content_ids: ecommerce.items.map((i) => i.item_id),
      contents: fbContents(ecommerce.items), num_items: ecommerce.items.reduce((n, i) => n + i.quantity, 0), order_id: ecommerce.transaction_id }, { eventID: eventId }]);
};
